const config = {
  REAL_API_URL: '/order-processing/rest/checkout',
  MOCK_API_URL: '/mock-checkout',
  LOGLEVEL: 4,
  IS_MOCK: false,
}

Object.defineProperty(config, 'API_URL', {
  get: function getApiUrl() {
    const url = (this.IS_MOCK) ? this.MOCK_API_URL : this.REAL_API_URL
    return url
  },
  configurable: true,
})

export default config
